export default {
    data() {
        return {
            viewSwitchAble: false
        }
    },
    created() {
        if (this.$route.query.viewSwitchAble) {
            this.viewSwitchAble = true;
        }
    },
    methods: {}
}
